import { render } from "./block_titulo_de_seccion.vue?vue&type=template&id=abd04cd0"
import script from "./block_titulo_de_seccion.vue?vue&type=script&lang=js"
export * from "./block_titulo_de_seccion.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/miqrositio/miqrositio_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__